import React from "react";
import bg from "../assets/netflix-bg.jpg";

export const BackgroundImage = () => {
  return (
    <div
      className="absolute inset-0 bg-cover bg-center sm:bg-contain lg:bg-cover"
      style={{ backgroundImage: `url(${bg})` }}
    ></div>
  );
};
